<template>
    <BaseTextImage
        v-bind="$props"
        :pending="pending"
        :use-parallax="true"
        :padding="true"
        :image-position="imagePosition"
    >
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
            :key="name"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
    </BaseTextImage>
</template>

<script setup>
defineProps({
    image: {
        type: Object,
        default: null,
    },
    pending: {
        type: Boolean,
        default: false,
    },
    link: {
        type: [String, Object],
        default: null
    },
    backgroundColor: {
        type: String,
        default: null,
    },
    customBackgroundColor: {
        type: String,
        default: null,
    },
    imagePosition: {
        type: Boolean,
        default: false
    }
});
</script>
